/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { budgetPredictionGetPrediction } from '../../axios/budgetPredictionGetPrediction'
import type {
	BudgetPredictionGetPredictionError,
	BudgetPredictionGetPredictionRequest,
	BudgetPredictionGetPredictionResponse,
} from '../../types/BudgetPredictionGetPrediction'

export const budgetPredictionGetPredictionMutationKey = () => [{ url: '/budget-prediction' }] as const

export type BudgetPredictionGetPredictionMutationKey = ReturnType<typeof budgetPredictionGetPredictionMutationKey>

export type BudgetPredictionGetPredictionVariables = {
	data: BudgetPredictionGetPredictionRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/BudgetPredictionController.php BudgetPredictionController::getPrediction */
export function useBudgetPredictionGetPrediction<TContext = unknown>(
	options?: UseMutationOptions<
		BudgetPredictionGetPredictionResponse,
		AxiosError<BudgetPredictionGetPredictionError>,
		BudgetPredictionGetPredictionVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: budgetPredictionGetPredictionMutationKey(),
		mutationFn: ({ data }: BudgetPredictionGetPredictionVariables) =>
			budgetPredictionGetPrediction(data, config).then(res => res.data),
		...options,
	})
}
